import { render } from "./OrderDataModals.vue?vue&type=template&id=8b8ea970&scoped=true"
import script from "./OrderDataModals.vue?vue&type=script&lang=js"
export * from "./OrderDataModals.vue?vue&type=script&lang=js"

import "./OrderDataModals.vue?vue&type=style&index=0&id=8b8ea970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b8ea970"]])

export default __exports__